import React from "react";

/**
 * CompatibilityRing — circular Ashtakoota Guna Milan verdict badge, mirrors the
 * mobile app's instant-verdict pill on match cards.
 *
 * Props:
 *   guna:    number 0..36 (from /home/feed match.guna_score)
 *   gunaMax: number (default 36)
 *   pct:     number 0..100 (from match.compat_pct)
 *   verdict: string ("Excellent match" / "Very good match" / ...)
 *   size:    number in px (default 72)
 *
 * Colour bands:
 *   >=80% crimson (auspicious), 65-79% gold, 45-64% ash, <45% muted
 */
const bandColor = (pct) => {
  if (pct == null) return "var(--ash)";
  if (pct >= 80) return "var(--crimson)";
  if (pct >= 65) return "var(--gold)";
  if (pct >= 45) return "var(--leaf)";
  return "var(--ash)";
};

export default function CompatibilityRing({ guna, gunaMax = 36, pct, verdict, size = 72 }) {
  const stroke = 6;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const safePct = Math.max(0, Math.min(100, Number.isFinite(pct) ? pct : 0));
  const dash = (safePct / 100) * c;
  const color = bandColor(safePct);

  return (
    <div data-testid="compat-ring" className="inline-flex flex-col items-center" style={{ width: size + 20 }}>
      <div style={{ position: "relative", width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: "rotate(-90deg)" }}>
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--line)" strokeWidth={stroke}/>
          <circle
            data-testid="compat-ring-arc"
            cx={size / 2} cy={size / 2} r={r} fill="none"
            stroke={color} strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={`${dash} ${c - dash}`}
          />
        </svg>
        <div style={{
          position: "absolute", inset: 0, display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", pointerEvents: "none",
        }}>
          <div className="font-serif" style={{ color, fontSize: size * 0.28, lineHeight: 1 }}>
            {guna != null ? `${guna}` : "—"}
            <span style={{ fontSize: size * 0.16, color: "var(--ash)" }}>/{gunaMax}</span>
          </div>
          <div className="text-[9px] tracking-widest uppercase mt-0.5" style={{ color: "var(--ash)" }}>
            Guna
          </div>
        </div>
      </div>
      {verdict && (
        <div className="mt-1 text-[9px] tracking-widest uppercase text-center leading-tight" style={{ color, maxWidth: size + 20 }}>
          {verdict.replace(" — Sagotra vivah blocked", "")}
        </div>
      )}
    </div>
  );
}
